
import { useEffect, useState } from "react"
import styled from "styled-components"
import InputText from "../shared/input/new/InputText"
import ehliyetOptions from "../../utils/ehliyetOptions"
import srcOptions from "../../utils/srcOptions"
import moment from "moment"
import locationData from "../../utils/locationData/locationOptions"
import { useDispatch } from "react-redux"
import { getUserPhoneNumberUnique, getUserTcApprove, getUserTcNoUnique, updateAdminUye } from "../../features/admin2/admin2Slice"
import InputDate from "../shared/input/new/InputDate"
import InputTextarea from "../shared/input/new/InputTextarea"
import InputCityTown from "../shared/input/new/InputCityTown"
import InputSelectMultiple from "../shared/input/new/InputSelectMultiple"
import InputSelect from "../shared/input/new/InputSelect"
import Btn from "../shared/button/Btn"
import { showModal } from "../../features/modal/modalSlice"
import { useSelector } from "react-redux"
import SmallSpinner from "../shared/spinners/SmallSpinner"
import { MdCheck } from "react-icons/md";
import dateConverter from "../../helper/dateConverter"

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .top-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding-bottom: 5px;
        border-bottom: 1px solid ${({theme}) => theme.mainTextColor};

        h4{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-md);
        }

        .update-text{
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-md);
            color: var(--color-main);
            text-decoration: underline;
            cursor: pointer;

        }
    }

    .main-content{
        display: flex;
        gap: 8px;

        .content-grp{
            width: 50%;
            display: flex;
            flex-direction: column;

            .content-item{
                width: 100%;
                display: flex;
                align-items: center;
                width: 100%;
                padding: 8px;
                border-radius: 5px;

                &:hover{
                    background-color: ${({theme}) => theme.secondaryBgColor};
                }

                .key{
                    width: 40%;
                    font-weight: var(--font-weight-lg);
                    font-size: var(--font-size-sm);
                }

                .row{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 54%;
                }

                .value{
                    width: 60%;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-sm);
                    display: flex;

                    .tc-dogrula-btn{
                        color: var(--color-main);
                        font-size: var(--font-size-sm);
                        font-weight: var(--font-weight-md);
                        padding-left: 20px;
                        cursor: pointer;
                        display: flex;
                        flex-direction: row;
                        text-decoration: underline !important;

                        .tc-checked{
                            color: var(--color-green);
                            display: flex;
                            align-items: center;
                            gap: 5px;
                        }

                        .tc-checked-icon{
                            font-size: 1rem;
                        }
                    }

                    .tc-dogrula-btn-passive {
                        cursor: initial !important;
                        text-decoration: none !important;
                    }
                }

                .phone-number-sorgula{
                    text-decoration: underline;
                    cursor: pointer;
                }
            }
        }
    }
    .button-grp{
        width: 100%;
        display: flex;
        justify-content: center !important;
        margin-top: auto;
        margin: 30px 0;
        gap: 50px;
    }
`

const kolayAdresTypes = [
    {
        id: 1,
        text: "TC No"
    },
    {
        id: 2,
        text: "Telefon"
    },
    {
        id: 3,
        text: "Vergi No"
    },
    {
        id: 4,
        text: "Pasaport No"
    },
    {
        id: 5,
        text: "Mail"
    },
]

const eYurtKayitliMiOptions = [
    {
        value: true,
        text: "Evet"
    },
    {
        value: false,
        text: "Hayır"
    }
]

const referanceCardData = [
    {
        value: true,
        text: "Evet"
    },
    {
        value: false,
        text: "Hayır"
    }
]

const AdminUyeItemDetay = ({uyeItemData}) => {

    const [isUpdateContent, setIsUpdateContent] = useState(false)

    const dispatch = useDispatch()

    const ehliyets = uyeItemData.ehliyetTypes.map(item => item.ehliyet)
    const srcs = uyeItemData.srcTypes.map(item => item.srcBelgesi)
    const { isLoadingGetUserTcApprove, userTCApprovedResData, userPhoneNumberUniqueResData, userTcNoUniqueResData } = useSelector(state => state.admin2)


    const [ehliyetTypes, setEhliyetTypes] = useState(ehliyetOptions.filter(item => ehliyets?.includes(item.value)))
    const [eYurtKayitliMi, setEYurtKayitliMi] = useState(eYurtKayitliMiOptions.find(item => item.value === uyeItemData.isEgeYurt))
    const [srcTypes, setSrcTypes] = useState(srcOptions?.filter(item => srcs?.includes(item.value)).length > 0 ? srcOptions?.filter(item => srcs?.includes(item.value)) : [srcOptions[srcOptions.length-1]])
    const [kolayAdresType, setKolayAdresType] = useState(kolayAdresTypes.find(item => item.text === uyeItemData?.kolayAdresType))
    const [cityTown ,setCityTown] = useState(locationData?.find(item => (item.city?.toLocaleLowerCase("tr") === uyeItemData?.il?.toLocaleLowerCase("tr")) && (item.town?.toLocaleLowerCase("tr") === uyeItemData?.ilce?.toLocaleLowerCase("tr"))))
    const [referanceStatus, setReferanceStatus] = useState(referanceCardData.find(item => item.value === uyeItemData?.IsReferenceCard))

    const [formData, setFormData] = useState({
        tcNo: uyeItemData?.tckn,
        adSoyad: uyeItemData?.adSoyadUnvan,
        dogumTarihi: uyeItemData?.dogumTarihi,
        phoneNumber: uyeItemData?.phoneNumber,
        iban: uyeItemData?.iban,
        adres: uyeItemData?.adres,
        firmaKooperatif:uyeItemData?.kooperatif,
        bankaBilgisiHesapSahibi: uyeItemData?.bankaBilgisiHesapSahibi,
        eYurtNo: uyeItemData?.eyurtNumber,
        kolayAdres: uyeItemData?.kolayAdres,
        kooperatifUyelikTarihi:moment(uyeItemData?.kooperatifUyelikTarihi, "DD/MM/YYYY")?.format('YYYY-MM-DD'),
        eyurtKayitTarihi: moment(uyeItemData?.eyurtKayıtTarihi, "DD/MM/YYYY")?.format('YYYY-MM-DD')
    })

    const handleChange = (e, isNumber) => {
        if(isNumber){
            setFormData((prev) => ({ ...prev, [e?.target?.name]: e?.target?.value.replace(/[^0-9]/g, '')}))
        }
        else{
            setFormData((prev) => ({ ...prev, [e?.target?.name]: e?.target?.value }))
        }
    }

    
    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    //! burada useEFccet ile ehliyet ve src verecen

    const handleSubmit = () => {

        if(formData.tcNo && formData.phoneNumber && formData.adSoyad && formData.adres && cityTown?.location && ehliyetTypes.length > 0 && srcTypes.length > 0){


            const data = {
                phoneNumber: formData.phoneNumber,
                tckn: formData.tcNo,
                adSoyadUnvan: formData.adSoyad,
                dogumTarihi: formData.dogumTarihi,
                adressContent: formData.adres,
                bankaBilgisiHesapSahibi: formData.bankaBilgisiHesapSahibi,
                iban: formData.iban,
                kolayAdresType: kolayAdresType?.text,
                kolayAdres:formData.kolayAdres,
                kooperatif: formData.firmaKooperatif,
                kooperatifUyelikTarihi: formData?.kooperatifUyelikTarihi !== "Invalid date" ? formData?.kooperatifUyelikTarihi : null,
                isEgeYurt: eYurtKayitliMi?.value,
                eyurtKayıtTarihi: formData?.eyurtKayitTarihi !== "Invalid date" ? formData?.eyurtKayitTarihi : null,
                eyurtNumber: parseInt(formData.eYurtNo) || 0,
                createdByUser: uyeItemData.createdByUser,
                createdByCompany: uyeItemData.createdByCompany,
                IsReferenceCard: referanceStatus?.value,
            }
            
            dispatch(updateAdminUye(
                {
                    ...data,
                    id:uyeItemData.id,
                    il: cityTown.city,
                    ilce: cityTown.town,
                    srcTypes: srcTypes.map(item => {
                        return {srcBelgesi: item.value}
                    }),
                    ehliyetTypes: ehliyetTypes.map(item => {
                        return {ehliyet: item.value}
                    })
                }
            ))
        }
    }

  return (
    <Container>
        <div className="top-container">
            {/* <div className="placeholder"/> */}
            <h4>Üye Bilgileri</h4>
            <span className="update-text" onClick={() => setIsUpdateContent(!isUpdateContent)}>{!isUpdateContent ? "Güncelle" : "Detayları Görüntüle"}</span>
        </div>
        <div className="main-content">
            <div className="content-grp">
                <div className="content-item">
                    <div className="key">Ad Soyadı*:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{uyeItemData.adSoyadUnvan}</div>
                        :
                        <InputText data={formData.adSoyad} setData={(e) =>handleChange(e)} inputWidth={"320px"} labelText="" name={"adSoyad"}/>
                        
                    }
                </div>
                <div className="content-item">
                    <div className="key">Telefon*:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{uyeItemData.phoneNumber}</div>
                        :
                        <div className="row">
                            <InputText data={formData.phoneNumber} setData={(e) =>handleChange(e, true)} inputWidth={uyeItemData?.phoneNumber !== formData?.phoneNumber ? "200px" : "320px"} labelText="" name={"phoneNumber"}/>
                            {uyeItemData?.phoneNumber !== formData?.phoneNumber && <Btn color="#E85446" bgColor="transparent" padding="10px" handleClick={() => dispatch(getUserPhoneNumberUnique(formData?.phoneNumber))} >Kontrol Et</Btn> }
                        </div>
                    }
                </div>
                <div className="content-item">
                    <div className="key">Doğum Tarihi:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{dateConverter(uyeItemData?.dogumTarihi, "tr")}</div>
                        :
                        <InputDate data={formData.dogumTarihi} setData={(e) =>handleChange(e)} inputWidth={"320px"} labelText="" name={"dogumTarihi"}/>
                    }
                </div>
                <div className="content-item">
                    <div className="key">TC No*:</div>
                    {
                        !isUpdateContent ? 
                            <div className="value">{uyeItemData.tckn} <span onClick={() => !uyeItemData.isTcNoValid && dispatch(getUserTcApprove({id: uyeItemData.id, tckn: formData.tcNo, adSoyadUnvan: formData.adSoyad, dogumTarihi: formData?.dogumTarihi}))} className={uyeItemData.isTcNoValid ? "tc-dogrula-btn tc-dogrula-btn-passive" : "tc-dogrula-btn"}>{isLoadingGetUserTcApprove ? <SmallSpinner size={"10px"} color={"#fff"} bgColor={"#E85446"}/> : uyeItemData.isTcNoValid ? <span className="tc-checked">Doğrulandı <MdCheck className="tc-checked-icon"/></span> : <span>Doğrula</span> }</span></div>
                        :
                        <div className="row">
                            <InputText data={formData.tcNo} setData={(e) =>handleChange(e, true)} inputWidth={uyeItemData?.tckn !== formData?.tcNo ? "200px" : "320px"} labelText="" name={"tcNo"}/>
                            {uyeItemData?.tckn !== formData?.tcNo && <Btn color="#E85446" bgColor="transparent" padding="10px" handleClick={() => dispatch(getUserTcNoUnique(formData?.tcNo))} >Kontrol Et</Btn> } 
                        </div>
                        }
                </div>
                <div className="content-item">
                    <div className="key">Ehliyet Türü:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{uyeItemData.ehliyetTypes.map((item, i) => i+1 === uyeItemData.ehliyetTypes.length ? item.ehliyet : `${item.ehliyet}, ` )}</div>
                        :
                        <InputSelectMultiple data={ehliyetTypes} setData={setEhliyetTypes} inputWidth={"320px"} labelText="" name={"ehliyetTypes"} options={ehliyetOptions}/>
                    }

                </div>
                <div className="content-item">
                    <div className="key">SRC Türü:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{uyeItemData.srcTypes.map((item, i) => i+1 === uyeItemData.srcTypes.length ? item.srcBelgesi : `${item.srcBelgesi}, ` )}</div>
                        :
                        <InputSelectMultiple data={srcTypes} setData={setSrcTypes} inputWidth={"320px"} labelText="" name={"srcTypes"} options={srcOptions}/>
                    }
                </div>
                <div className="content-item">
                    <div className="key">Adres İlçe/İl:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{uyeItemData.ilce}/{uyeItemData.il}</div>
                        :
                        <InputCityTown data={cityTown?.location} setData={setCityTown} inputWidth={"320px"} labelText="" name={"cityTown"}/>
                    }
                </div>
                <div className="content-item">
                    <div className="key">Adres:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{uyeItemData.adres}</div>
                        :
                        <InputTextarea data={formData.adres} setData={(e) =>handleChange(e)} inputWidth={"320px"} labelText="" name={"adres"}/>
                    }
                </div>
            </div>
            {/* <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={() => {}}>Kaydet</Btn> */}
            <div className="content-grp">            
                <div className="content-item">
                    <div className="key">Banka Hesap Sahibi:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{uyeItemData.bankaAdSoyadHesap}</div>
                        :
                        <InputText data={formData.bankaBilgisiHesapSahibi} setData={(e) =>handleChange(e)} inputWidth={"320px"} labelText="" name={"bankaBilgisiHesapSahibi"}/>
                        }
                </div>
                <div className="content-item">
                    <div className="key">IBAN:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{uyeItemData.iban}</div>
                        :
                        <InputText data={formData.iban} setData={(e) =>handleChange(e, true)} inputWidth={"320px"} labelText="" name={"iban"}/>
                    }
                </div>
                <div className="content-item">
                    <div className="key">Kolay Adres Türü:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{uyeItemData.kolayAdresType}</div>
                        :
                        <InputSelect data={kolayAdresType?.text} setData={setKolayAdresType} inputWidth={"320px"} labelText="" name={"kolayAdresType"} initialOptions={kolayAdresTypes}/>
                    }
                </div>
                <div className="content-item">
                    <div className="key">Kolay Adres:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{uyeItemData.kolayAdres}</div>
                        :
                        <InputText data={formData.kolayAdres} setData={(e) =>handleChange(e)} inputWidth={"320px"} labelText="" name={"kolayAdres"}/>
                    }
                </div>
                <div className="content-item">
                    <div className="key">Üye Olduğu Kooperatif:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{uyeItemData.kooperatif}</div>
                        :
                        <InputText data={formData.firmaKooperatif} setData={(e) =>handleChange(e)} inputWidth={"320px"} labelText="" name={"firmaKooperatif"}/>
                    }
                </div>
                <div className="content-item">
                    <div className="key">Kooperatif üyelik Tarihi:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{uyeItemData.kooperatifUyelikTarihi}</div>
                        :
                        <InputDate data={formData.kooperatifUyelikTarihi} setData={(e) =>handleChange(e)} inputWidth={"320px"} labelText="" name={"kooperatifUyelikTarihi"}/>
                    }
                </div>
                <div className="content-item">
                    <div className="key">E-Yurt Kayıtlı Mı?:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{uyeItemData.isEgeYurt ? "Evet" : "Hayır"}</div>
                        :
                        <InputSelect data={eYurtKayitliMi?.text} setData={setEYurtKayitliMi} inputWidth={"320px"} labelText="" name={"eYurtKayitliMi"} initialOptions={eYurtKayitliMiOptions}/>
                    }
                </div>
                <div className="content-item">
                    <div className="key">Referans Kartı Olsun Mu?:</div>
                    {
                        !isUpdateContent ? 
                        <div className="value">{uyeItemData.IsReferenceCard ? "Evet" : "Hayır"}</div>
                        :
                        <InputSelect data={referanceStatus?.text} setData={setReferanceStatus} inputWidth={"320px"} labelText="Referans Kartı Durumu" name={"referanceStatus"} initialOptions={referanceCardData}/>
                    }
                </div>
                {
                    eYurtKayitliMi?.text === "Evet" &&
                    <div className="content-item">
                        <div className="key">E-Yurt Kayıt Tarihi:</div>
                        {
                            !isUpdateContent ? 
                            <div className="value">{uyeItemData.eyurtKayıtTarihi}</div>
                            :
                            <InputDate data={formData.eyurtKayitTarihi} setData={(e) =>handleChange(e)} inputWidth={"320px"} labelText="" name={"eyurtKayitTarihi"}/>
                        }
                    </div>
                }
                {/* <div className="content-item">
                    <div className="key">Egeyurt Referans Mı?:</div>
                    <div className="value"></div>
                </div> */}
                {
                    !isUpdateContent && 
                    <>
                        <div className="content-item">
                            <div className="key">Kamyoon Üyelik Tamamlandı mı?:</div>
                            <div className="value"></div>
                        </div>
                        <div className="content-item">
                            <div className="key">Kaydeden Kullanıcı:</div>
                            <div className="value">{uyeItemData.createdByUser}</div>
                        </div>
                        <div className="content-item">
                            <div className="key">Kaydeden Firma:</div>
                            <div className="value">{uyeItemData.createdByCompany}</div>
                        </div>
                        <div className="content-item">
                            <div className="key">Kamyoon Versiyonu:</div>
                            <div className="value">{uyeItemData.appVersionNumber}</div>
                        </div>
                    </>
                }
            </div>  
        </div>
        <div className="button-grp">
            {
                isUpdateContent &&
                <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={() => handleSubmit()}>Güncelle</Btn>
            }
            <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={() => dispatch(showModal(null))}>Geri Dön</Btn>
        </div>
    </Container>
  )
}

export default AdminUyeItemDetay